// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"cf158dc1","726":"a23feb38","787":"cda612ba"}[chunkId] + ".chunk.js";
};